import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
  input,
  output,
} from '@angular/core';
import { Page, PageRequest } from '$synapse/models';
import { ActivatedRoute, Router, UrlCreationOptions } from '@angular/router';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class PaginationComponent implements OnChanges {
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);

  @Input()
  page: Page<unknown>;

  @Input()
  siblingCount = 2;

  readonly queryParamsHandling =
    input<UrlCreationOptions['queryParamsHandling']>('preserve');
  readonly changePage = output<PageRequest>();

  range: (number | '...')[];

  ngOnChanges(changes: SimpleChanges): void {
    this.range = this.buildRange();
  }

  private buildRange(): (number | '...')[] {
    const total = this.page.totalPages;
    const current = this.page.number;
    const sib = this.siblingCount;

    if (total <= 1) {
      return [1];
    }

    const start = Math.max(2, current - sib);
    const end = Math.min(total - 1, current + sib);

    const rangeBuild: (number | '...')[] = [1];

    if (start > 2) {
      rangeBuild.push('...');
    }

    for (let i = start; i <= end; i++) {
      rangeBuild.push(i);
    }

    if (end < total - 1) {
      rangeBuild.push('...');
    }

    rangeBuild.push(total);

    return rangeBuild;
  }

  get first() {
    return this.page.number === 1;
  }

  get last() {
    return this.page.number === this.page.totalPages;
  }

  setCurrentPage(page: PageRequest) {
    this.changePage.emit(page);
    const queryParamsHandling = this.queryParamsHandling();
    if (queryParamsHandling !== 'preserve') {
      this._router.navigate(['.'], {
        relativeTo: this._route,
        queryParams: page.params(),
        queryParamsHandling: queryParamsHandling,
      });
    }
  }
}
